import { Component, OnInit, Inject, HostListener, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
//services
import { StoreService } from 'src/app/services/store.service';
import { SharedService } from 'src/app/services/shared.service';
import { SEOService } from 'src/app/services/seo.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  data: Observable<any>;
  user: Observable<any>;
  restaurant_address: string = '';

  scrolled: boolean = false;
  activePath: any;

  last_scroll_top = 0;
  showHeaderClass = true;
  hideHeaderClass = false;
  coloredHeader = false;


  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    public router: Router,
    private storeService: StoreService,
    private sharedService: SharedService,
    private seoService: SEOService,
    private analyticsService: AnalyticsService
  ) {
    /**RESTORE POLICY IN REDUX STORE UPON REFRESH**/
    this.storeService.storeExistingSelectedPolicy(); // restore existing selected policy
    this.storeService.storeExistingDeliveryTime(); // restore existing delivery time
    this.storeService.setExistingPaymentMethod(); // restore existing delivery time
    this.storeService.storeExistingCartData(); // restore existing cart data
    this.storeService.storeExistingAvailablePromotion(); // restore existing available promotion data
    this.storeService.storeExistingAcceptedPromotion(); // restore existing accepted promotion data
    this.storeService.storeExistingOrderNotes(); // restore existing accepted promotion data
    this.storeService.storeExistingLoginData(); // restore existing accepted promotion data

    this.data = this.storeService.restaurantData;
    this.user = this.storeService.user;

    /**CHECK RESTAURANT INFORMATION IN REDUX STORE THEN, GENERATE RESTAURANT SCHEDULE**/
    this.data.subscribe(result => {
      if (Object.getOwnPropertyNames(result).length !== 0) {
        // this.sharedService.scheduleProcessing();

        /*restaurant address*/
        let res_postcode = '';
        if (result.restaurant_data.street_address) {
          res_postcode = res_postcode.concat(', ' + result.restaurant_data.street_address.replace(/,\s*$/, '').trim());
        }
        if (result.restaurant_data.local_area) {
          res_postcode = res_postcode.concat(', ' + result.restaurant_data.local_area.replace(/,\s*$/, '').trim());
        }
        if (result.restaurant_data.city_or_town) {
          res_postcode = res_postcode.concat(', ' + result.restaurant_data.city_or_town.replace(/,\s*$/, '').trim());
        }
        if (result.restaurant_data.postcode) {
          res_postcode = res_postcode.concat(' ' + result.restaurant_data.postcode.trim());
        }
        this.restaurant_address = res_postcode.replace(/^,/, '').trim();

        const homePageData = result?.restaurant_content?.home_page;
        if (homePageData) {
          this.seoService.setPageTitle(homePageData.seo_page_title);// set page title
          this.seoService.addMetaTag(homePageData.seo_meta); // meta data
          this.analyticsService.init(homePageData.google_analytics);
          this.analyticsService.createSchema(homePageData.schema);
          this.analyticsService.createCustomJavaScript(homePageData.custom_content);
          
          this.analyticsService.createCustomNoScript(homePageData.custom_no_script);
        }
      }
    });
    /**END**/
  }



  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activePath = event.url.split('/')[1] || 'default';
      }
    });
  }


  @HostListener("window:scroll", [])
  onWindowScroll() {
    if (this.activePath === 'order-online') {
      return
    }
    else {
      this.scrolled = window.scrollY > 0;
    }
  }


}

